<style>
  p{
  text-align: justify;
  }
  ol ol li{
    list-style-type: square;
  }
</style>
<div class="col-height ml-3 pt-3 pb-5">
  <div class="row only-web" style="width: 95%;margin:20px 0">
    <div class="col-9 margin-auto">
      <img src="assets/images/logo-cla.png" alt="CapitaStar&#64;Work Logo" style="width:7em">
    </div>
    <!-- <div class="col-6 margin-auto text-center" style="font-size: 2em;">
      CapitaStar&#64;Work India
    </div> -->
    <div class="col-3 margin-auto text-right">
      <img src="assets/images/capitaland-cla-logo.png" alt="CapitaLand Logo">
    </div>
  </div>

  <div class="row ">
    <span>Terms & Conditions</span>
  </div>
  <div class="row">
    <div class="col-11">
      <!-- <div class="row" style="font-size: 2em;">
        CapitaStar&#64;Work India
      </div> -->
      <h1 class="mt-4">CapitaStar&#64;Work India - Terms and Conditions ("Terms")</h1>
      <br>
      <!-- <h2 class="mt-3">Last updated: (15 April 2021)</h2> -->
      <p id="p"> Please read these terms of use carefully. These terms of use (the “Terms”) set out the terms and conditions that govern your download, installation and use of the CapitaStar&#64;Work India mobile application (“CapitaStar&#64;Work India” or the “Application” or the “App”) that is owned, controlled and provided by CapitaLand Services (India) Pvt Ltd  (“ CapitaLand ” or the “Company”). By downloading, installing, accessing and/or using the App, you agree to these Terms and acknowledge them to be binding on you. If you do not agree to these Terms, please do not download and install the App. If you have already done so, please do not access and/or use the App, and delete the App from all of your devices on which it is installed. You hereby undertake to comply fully with the Terms in your use of the application.</p>

      <!------------------ 1. Eligibility and Agreement ------------------------------->

      <h2>1. Eligibility and Agreement</h2>
      <p>These Terms represent an agreement entered into between you and the Company concerning the use by you of the
        App and the App Services. This App is only available to you if you are at least twelve (12) years of age. By
        opening an account and/or using the App, you represent that you are at least twelve (12) years of age. By
        using the App and/or the App Services, you further represent and warrant that you have the right, authority and
        capacity to use the App and/or the App Services and to abide by these Terms. These Terms may be amended or
        supplemented from time to time by the Company at its sole discretion, by posting revisions or revised Terms
        through or on the App. Your continued use of the App and/or App Services following the posting of any changes or
        modifications to the Terms will constitute your acceptance of such changes, modifications, supplements or of
        such modified Terms. (“App Services” means amongst other things any of the Internet-based, mobile based,
        interactive information services, content, or interactive tools that may be provided by the Company at the
        Company’s sole discretion, and that may be used or accessible by means of the App, including without limitation
        enabling users to browse and place orders for food and beverage products and services, or food and beverage
        related products and services, from Merchants (defined below) located in or near premises that are owned,
        controlled or operated by the Company or its affiliates), to monitor Merchant queue lengths and times, and to
        receive useful information regarding promotions, events and other announcements.
      </p>
      <!------------------ 2. Licence Grant ------------------------------->
      <h2> 2. Licence Grant</h2>
      <p> In consideration of your undertaking to comply with these Terms, the Company hereby grants to you a limited,
        non-exclusive, non-transferable, non-sub licensable, non-assignable, terminable and revocable license to
        download, install, access and use the App and/or the App Services provided therein (the “License”), provided
        that your access and use of the same is strictly in accordance with these Terms. For the avoidance of doubt, the
        Application is licensed, not sold, to you by the Company pursuant and subject to these Terms. The Company
        reserves all rights not expressly granted to you herein.
      </p>
      <!------------------ 3. Account ------------------------------->
      <h2> 3. Account</h2>
      <ol>
        <li>
          <p>Prior to using the App, you are required to set up an account through the App or such other means as may be
            offered by the Company from time to time. You acknowledge and agree that you are responsible for maintaining the
            confidentiality, safekeeping and security of your account information, and you shall notify the Company
            immediately of any unauthorised use of your account information.
          </p>
        </li>
        <li>
          <p>
            Without prejudice to the foregoing, you shall be solely liable and responsible for any activity conducted
            using your account information, unless you have notified the Company in writing of the closure or misuse of your
            account and the Company has received such notification.
          </p>
        </li>
      </ol>
     
      <!------------------ 4. Use of the App ------------------------------->
      <h2>4. Use of the App</h2>
      <ol>
        <li>
          <p>You acknowledge and agree that you are responsible for any and all information, content and image that you upload on the App, and you hereby grant to the Company a worldwide, transferable and sub-licensable right to use, copy, modify, distribute, publish, and process information, content and image that you provide through our App Services, without any further notice and/or compensation to you or others.</p>
        </li>
        <li>
          <p>
            In using the App, you acknowledge and agree that:
          </p>
          <ol>
            <li>
              <p>
                "Merchants" (i.e. meaning a third party seller of food and beverage products and services and food and beverage related products and services which you can purchase through the App) set the price and availability of their products and services, which means that the Company has no control over the availability or price of the products and services. You are responsible for reviewing each order before paying for it.
              </p>
            </li>
            <li>
              <p>
                Once you have confirmed your order, we do not encourage to change or cancel the same.  However, in case you need to cancel or change the order, the same will be subject to the refund policy as detailed under each amenities. 
              </p>
            </li>
            <li>
              <p>
                In case of orders placed with Merchants, the Company does not guarantee any refund on behalf of the Merchant. The refund can be claimed according to the respective merchant’s refund policy. The contact details of Merchants can be found within the App. 
              </p>
            </li>
            <li>
              <p>
                If the Merchant rejects your order or does not accept your order within the time stipulated by the Company, your order will time out and you will be notified accordingly through the App. In this instance, you will not be charged for your order or transaction.
              </p>
            </li>
            <li>
              <p>
                It is your responsibility to pick up your ordered products from the Merchant when they are made available to you. When your order is confirmed, you will be notified via the App of the estimated time it will take for your ordered products to be ready for pick up.
              </p>
            </li>
            <li>
              <p>
                The Company shall not be responsible for the availability, dispatch or condition of any product or services supplied by the Merchant.
              </p>
            </li>
            <li>
              <p>
                If you detect an unauthorised order or suspect that your CapitaStar&#64;Work India account has been compromised in anyway, you should change your password and inform the Company immediately.
              </p>
            </li>
            <li>
              <p>
                The Merchants are third party merchants whose products and services are hosted on the App and they shall not in any way be construed as employees or agents of the Company;
              </p>              
            </li>
            <li>
              <p>
                All transactions conducted through the App will follow the international timings as shown in the App;
              </p>
            </li> 
            <li>
              <p>
                You will only use the App and/or the App Services for lawful purposes and the purpose for which it is intended to be used;
              </p>
            </li>
            <li>
              <p>
                You shall not license, sublicense, sell, resell, transfer, assign, distribute or otherwise commercially exploit or make available to any third party the Application and/or the App Services in any way;
              </p>
            </li>
            <li>
              <p>
                You shall not transmit, post, distribute, store or destroy material, in violation of any applicable law or regulation;
              </p>
            </li>
            <li>
              <p>
                You shall not use any data mining, robots or similar data gathering or extraction methods;
              </p>
            </li>
            <li>
              <p>
                You shall not transmit or link to viruses, worms, defects, Trojan horses, malware or any other items that may introduce security vulnerabilities to or harm user devices, apps or personal data;
              </p>
            </li>
            <li>
              <p>
                You will not use the App and/or the App Services to cause any inconvenience or make fake bookings;
              </p>
            </li>
            <li>
              <p>
                You shall not violate or attempt to violate the security of the App including attempting to probe, scan or test the vulnerability of a system or network or to breach security or authentication measures without proper authorization;
              </p>
            </li>
            <li>
              <p>
                You shall not transmit any content or material that promotes or endorses false or misleading information or illegal activities, or endorses or provides instructional information about illegal activities or other activities prohibited by law or by these Terms, such as making or buying illegal weapons, violating someone's privacy, providing or creating computer viruses or pirating media;
              </p>
            </li>
            <li>
              <p>
                You shall not post, share or transmit images which is defamatory, vulgar, offensive, erose communal feelings, abusive and indecent. 
              </p>
            </li>
            <li>
              <p>
                You shall not share with a third party any of your account information;
              </p>
            </li>
            <li>
              <p>
                You shall not access data not intended for you or log into a server or account which you are not authorized to access;
              </p>
            </li>
            <li>
              <p>
                You shall not post or submit to the App any incomplete, false or inaccurate information about yourself or information which is not your own;
              </p>
            </li>
            <li>
              <p>
                You shall not solicit passwords or personal data or images from any other person or entity;
              </p>
            </li>
            <li>
              <p>
                You shall not delete or alter any material posted by any other person or entity;
              </p>
            </li>
            <li>
              <p>
                You shall not harass, incite harassment or advocate harassment of any group, company or individual; and
              </p>
            </li>
            <li>
              <p>
                You shall not use the App for any unlawful purpose or any illegal activity, or post or transmit any content or image that is defamatory, libellous, implicitly or explicitly offensive, vulgar, obscene, threatening, abusive, hateful, racist, discriminatory, of a menacing character or likely to cause annoyance, inconvenience, embarrassment, anxiety or could cause harassment to any person or include any links to pornographic, indecent or sexually explicit material of any kind, as determined by the Company, at its sole and absolute discretion.
              </p>
            </li>
          </ol>
        </li>
      </ol>  

      <!------------------ 5. Personal Data Protection ------------------------------->
      <h2> 5. Personal Data Protection</h2>
      <ol>
        <li>
          <p>
            In the course of your use of the Application, and to provide you with the App Services, the Company may be required to collect, use, disclose and/or process personal data (including images if any) belonging to you, or that may relate to a third party individual and as provided by you. In this regard, the Company will collect, use, disclose and/or process your personal data  as set out in clause 5(2). The image if any posted by you in the Application shall be collected by the Company for the specific purpose of profile picture display and such images shall not be used for any other purpose.    
          </p>
        </li>
        <li>
          <p>
            Without prejudice to our Privacy Policy, the Company collects, uses and discloses your personal data strictly for the purposes of providing you with the Application and the App Services, and includes purposes such as:
          </p>
          <ol>
            <li>
              <p>Creating and maintaining your user account;</p>
            </li>
            <li>
              <p>Processing transactions and payments made by you;</p>
            </li>
            <li>
              <p>Sending you relevant notices and services messages;</p>
            </li>
            <li>
              <p>For internal administrative purposes; and</p>
            </li>
            <li>
              <p>Performing data analytics, including the observing of consumer behaviour and patterns.</p>
            </li>
          </ol>
        </li>          
        <li>
          <p>By downloading, installing and using the Application, you hereby agree and consent to the Company collecting, using and/or processing your personal data (including images if any) for the purposes set out above and in our Privacy Policy.</p>
        </li>
        <li>
          <p>You may also withdraw your consent to the collection, use and disclosure of your personal data for the purposes set out above at any time by giving writing in notice to the address set out below. If you withdraw such consent, the Company may not be able to continue providing you with the use of the Application and/or the App Services, and you hereby acknowledge and agree to accept any such consequences of your withdrawal of your consent. You may withdraw consent by writing to us at: <a href="mailto:capitastar.india&#64;capitaland.com">capitastar.india&#64;capitaland.com</a></p>
        </li>
        <li>
          <p>Account Deletion: You can delete your account from the app by clicking the "Deactivate/Delete" button in the profile section. By doing so, the CapitaStar&#64;Work app will erase all personal data associated with your account, including your name, phone number, and email address collected during the registration process. Once your account is deleted, the app will no longer provide its services until you re-register.</p>
        </li>      
      </ol>   
      
     <!------------------ 6. Payment and Charges ------------------------------->
      <h2> 6. Payment and Charges</h2>
      <ol>
        <li>
          <p>You understand that your use of the App Services will result in charges to you for the products and
            services that you order from the Merchants, including a transaction fee applicable to each order. Payment of
            such charges will be processed by the Company's designee, via third party payment gateways as may be
            designated in your user account. Usage of such third party payment gateways may require you to register a
            valid credit or debit card which belongs to you (or if it belongs to another person, you hereby warrant that
            you have obtained their consent to use the credit or debit card for payment of the App Services) in accordance
            with the instructions provided by such third party payment gateways. If your credit or debit card or other
            payment facility is invalid, unauthorised, or suspended, your access to and usage of the App and/or the App
            Services may be suspended or cancelled immediately without notice.
          </p>
        </li>
        <li>
          <p>All payments made will be inclusive of applicable taxes where required by law, and are final.
          </p>
        </li>
        <li>
          <p>The Company may from time to time offer you certain promotional codes which may be used in conjunction
            with your orders placed with Merchants via the Application. Unless otherwise stated, promotional codes are not
            valid in conjunction with any other promotions or discounts. Promotional codes are not transferable or
            redeemable for cash or credit. Each specific promotional code will specify further terms and conditions (for
            example, duration, discount amount and Merchants/products/services covered) which will govern the use and
            redemption of promotional codes in addition to these Terms. The Company may alter the terms of any promotional
            code at any time without notice. The Company may cancel or modify orders, or revoke the use of any promotional
            code, where the promotional code has been used in a suspicious or fraudulent manner and/or in bad faith.
          </p>
        </li>
        <li>
          <p>Additionally, you should be aware that your network provider may charge you both for access to its
            connection services and for the duration of your mobile phone's connection while accessing the App Services
            and/or using the Application (these charges may include without limitation GPRS or Circuit Switch Data
            charges). You are solely responsible for these costs and the costs of any other third party associated with
            your receiving the App Services and/or using the Application.
          </p>
        </li>       
      </ol>
     
      <!------------------ 7. Start Date and Cancellation of Services ------------------------------->  
      <h2>7. Start Date and Cancellation of Services</h2>
      <ol>
        <li>
          <p> Your subscription to the App Services commences on the date you are able to receive the App Services,
            provided always that the Company may determine the start date of the App Services, and that the Company may
            refuse to provide the App Services or refuse commencement of the App Services, without having to assign any
            reason for such refusal and without being liable to you for any compensation whatsoever.
          </p>
        </li>
        <li>
          <p> You may uninstall the Application at any time if you desire to stop receiving the App Services or use of
            the Application.
          </p>
        </li>
      </ol>

      <!------------------ 8. Intellectual Property ------------------------------->  
      <h2>8. Intellectual Property</h2>
      <ol>      
        <li>
          <p>You acknowledge that the Company and its affiliates, or other third parties own all rights, title and
          interest in and to the Application and technology comprised in the App Services, including without limitation
          software and portions thereof and all Intellectual Property Rights, and you shall not do or permit any act
          which is directly or indirectly likely to prejudice the rights, title or interest of the said rightful
          owner(s) in and to any of the aforesaid. “Intellectual Property Rights” means any and all rights existing from
          time to time (both current and future) under patent law, copyright law, trade secret law, trademark law,
          unfair competition law, and any and all other proprietary rights, and any and all applications, renewals,
          extensions and restorations thereof, now or hereafter in force and effect worldwide, or capable of protection
          in any relevant country in the world.
          </p>
        </li>
        <li>
          <p>Unless otherwise expressly permitted by mandatory applicable law, you agree not to modify, adapt,
            translate, prepare derivative works from, or decompile, reverse engineer, disassemble or otherwise attempt to
            derive source code from, the Application. You shall not rent, lease, lend, sell, redistribute or sub-license,
            the Application. “CapitaStar&#64;Work India” and all related trademarks belong to the Company
            and/or its affiliates, and any other trademarks that you may have sight of when using the App Services are the
            property of their respective owners. Without prejudice to the generality of the foregoing, you shall not use
            in any way and shall not reproduce any trademarks that are associated with the Application or App Service or
            that you have sight of when using the App Services, without the prior written consent of the Company.
          </p>
        </li>
        <li>
          <p>You also agree to not remove, obscure or alter the Company’s or any third party’s copyright notice,
            trademarks, or other proprietary rights notices affixed to or contained within or accessed in conjunction with
            or through the Application.
          </p>
        </li>
      </ol>

      <!------------------ 9. Disclaimer of Warranties and Limitation of Liability ------------------------------->  
      <h2> 9. Disclaimer of Warranties and Limitation of Liability</h2>
      <ol>
        <li>
          <p>You acknowledge and agree that the Application and the App Services are provided on an “as is” basis,
            and to the maximum extent permitted by law, the Company disclaims all warranties and makes no warranty of any
            kind, whether express or implied (statutory or otherwise), including but not limited to warranties on the
            merchantability, sufficiency, quality and fitness for a particular purpose of the Application and/or the App
            Services. The Company further makes no warranty that the Application and App Services do not infringe the
            rights (including Intellectual Property Rights) of any party. You wholly assume all risks in your use of the
            Application and receipt/use of the App Services. Without limiting the generality of the foregoing, the Company
            does not warrant and excludes all liability in respect of:
          </p>
          <ol>
            <li>
              <p>The accuracy, completeness, fitness for purpose or legality of any information published by the Company or that are communicated to you relating to the Application and/or the App Services; and
              </p>
            </li>
            <li>
              <p> The Application and/or App Services in respect of their quality, usability, fitness for purpose or any other aspect thereof.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>The Company disclaims any warranties regarding security, reliability, timeliness, and performance of the
            Application. You further understand and agree that you download and/or use the Application at your own
            discretion and risk and that you will be solely responsible for any loss or damages to your mobile device
            system or computer or loss of data that results from the download or use of the Application.
          </p>
        </li>
        <li>
          <p>The Company makes no guarantee, representation or warranty whatsoever that :</p>
          <ol>
            <li>
              <p>The App Services or the Application will be error free;</p>
            </li>
            <li>
              <p>You will be able to use the Application or that you will be able to access, use or receive the App Services; and/or
              </p>
            </li>
            <li>
              <p>Any information provided via the App Services is accurate.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>You acknowledge that the use of the App Services presents the possibility of human and machine errors,
            inaccuracies, omissions, delays, and losses, including the inadvertent loss of data which may give rise to
            loss or damage suffered by you, and you agree and undertake that you shall not hold the Company liable in any
            way whatsoever for the said loss or damage.
          </p>
        </li>
        <li>
          <p>The Company assumes no responsibility for the representations, information, activities or conduct of the Merchants listed on the Application. For the avoidance of doubt, you acknowledge and agree that the Application is only a platform for the purposes of remotely placing orders for products and services from the Merchants and facilitating the transactions between Merchants and customers. You understand that the quality of the products and services ordered through the App and provided to you by the Merchant is entirely the responsibility of the Merchant. You therefore agree that Ascendas will not be responsible for any loss, damage, costs or expenses that you may suffer or incur as a result of the representations, information, activities or conduct of the Merchants.
          </p>
        </li>
        <li>
          <p>To the maximum extent permitted by law, you agree that the Company shall not be liable to you in
            contract, tort (including negligence or breach of statutory duty) or otherwise howsoever and whatever the
            cause thereof, for any indirect, consequential, collateral, special or incidental loss or damage suffered or
            incurred by you in connection with the App Services or the Application, whether during or after the
            termination of the Licence. For the purposes of this clause, indirect or consequential loss or damage
            includes, without limitation, loss of existing or anticipated revenue or profits, anticipated savings or
            business, loss of data or goodwill, business interruption, loss of use or value of any equipment including
            software, claims of third parties, and all associated and incidental costs and expenses.
          </p>
        </li>
        <li>
          <p>Where the Company's liability is not expressly excluded under these Terms or under any applicable law,
            the Company's liability to you in contract, tort (including negligence) or otherwise whosoever and whatever
            the cause thereof, arising by reason of or in connection with these Terms, the Application and/or the App
            Services, shall be limited to the aggregate amount of all amounts actually paid by and/or due from you in
            utilising the App Services during the event giving rise to such claims.
          </p>
        </li>
        <li>
          <p>Notwithstanding anything that may be to the contrary, no action may be brought by you against the
            Company, under these Terms or related to the App Services or the Application, more than one (1) year after the
            cause of action arose. For the avoidance of doubt, this limitation shall not apply to claims (including
            counterclaims) by the Company against you.
          </p>
        </li>
        <li>
          <p>The Company retains absolute discretion in determining whether or not to provide maintenance and support
            services for the Application, and if so, the type of maintenance and support services.
          </p>
        </li>
        <li>
          <p>Nothing in the contents of the Application shall be considered an endorsement, representation or
            warranty of or by the Company with respect to any third party or any third party's content, products, services
            or otherwise. Without limiting the generality of the foregoing, the foregoing applies to any paid advertising
            content, as well as links that may be provided in the Application to third party websites or applications.
            Such links (if any) are provided solely as a convenience to you. You use such links to access third party
            content, websites or applications at your own risk. The Company makes no representations or guarantees
            regarding the availability or content (including its truthfulness, accuracy, completeness, timeliness or
            reliability) of such third party content, websites or applications in respect of which links have been
            provided in the Application, nor with regard to broken links.
          </p>
        </li>
        <li>
          <p>Your dealings with any advertisers (including Merchants) on CapitaStar&#64;Work India are solely between
            you and such advertisers. You agree that the Company will not be responsible for any loss, damage, costs or
            expenses that you may suffer or incur as a result of any such dealings or otherwise arising from the presence
            of such advertisers on CapitaStar&#64;Work India.
          </p>
        </li>       
      </ol>
     
      <!------------------ 10. Alteration to the Services and Termination ------------------------------->      
      <h2> 10. Alteration to the Services and Termination</h2>
      <ol>
        <li>
          <p>The Company may amend all or part of the App Services including the contents therein at any time.</p>
        </li>
        <li>
          <p>The Company has the right to, and you acknowledge that the Company can, withdraw any information, data
            or content forming a part of the App Services, or immediately suspend, withdraw or terminate the Licence
            (including the App Services entirely) and/or terminate these Terms, at any time, without liability and without
            notice to you, for any or no reason whatsoever. You shall not hold the Company liable in any way whatsoever
            for any of the aforesaid. Without limiting the generality of the foregoing, in the event that any information
            provided by you is inaccurate, in breach of any laws or contains indecent elements, the Company has the right
            to instantly terminate your account without notice and take all such action as it considers appropriate,
            desirable or necessary including but not limited to taking legal actions against such user.
          </p>
        </li>      
      </ol>
     
      <!------------------ 11. Unpredictable nature of the App Services -------------------------------> 
      <h2> 11. Unpredictable nature of the App Services</h2>      
      <p> You understand and acknowledge that the transmission of information through telecommunications channels is
        unpredictable in nature and depends on, amongst other issues (i) third party telecommunications operators, and
        (ii) the proper maintenance of your receiving equipment. The Company gives no guarantee of the continued
        availability and quality of reception of the App Services and/or the Application.
      </p>

      <!------------------ 12. Interruption of the App Services -------------------------------> 
      <h2> 12. Interruption of the App Services</h2>
      <p> The App Services may be interrupted, in whole or in part, in a case of force majeure (being events outside
        the control of either you, the Merchants, or the Company) or during periods of maintenance or for any other
        reason whatsoever. Without prejudice to clause 9, the Company and its related corporations cannot be held
        liable for any loss or damages caused directly or indirectly by the interruption of all or part of the App
        Services in the case of force majeure or for any other reason, nor loss of profits, contracts, reputation, nor
        for any consequential loss of any kind. For the avoidance of doubt, the Company does not exclude its liability
        for death or personal injury caused from its negligence, or the negligence of its employees or agents.
      </p>

      <!------------------ 13. Non-transferable rights and Indemnity -------------------------------> 
      <h2> 13. Non-transferable rights and Indemnity</h2>
      <ol>
        <li>
          <p>The rights to use the App Services and the Application are personal to you, and you may not transfer or
            assign to a third party any of your rights and obligations as defined in these Terms or any other document
            constituting this agreement unless you have obtained the prior written consent of the Company to do so.
          </p>
        </li>
        <li>
          <p>You agree to indemnify, defend and hold the Company, its related corporations, including their
            respective successors, assigns, employees, officers, harmless from and against all claims, demands, actions,
            losses, damages, costs and expenses (including legal fees), arising out of and in connection with your breach
            of these Terms, your use of the Application, your receipt or use of the App Services, your dealings with the
            Service Providers, your failure to obtain the requisite insurance in relation to the operation of your vehicle
            by a Service Provider to complete any given journey as agreed through the App, and/or your failure to comply
            with any applicable law or regulation.
          </p>
        </li>
      </ol>
     
      <!------------------ 14. Territory and Governing law and Dispute Resolution ------------------------------->
      <h2> 14. Territory and Governing law and Dispute Resolution</h2>
      <ol>
        <li>
          <p>The scope of these Terms covers the territory of India. These Terms are governed by and shall be construed in accordance with the laws of India, excluding its conflicts of laws principles.
          </p>
        </li>
        <li>
          <p>Any dispute arising out of or in connection with this Agreement, including any question regarding its
            existence, validity or termination, shall be referred to and finally resolved by arbitration before a single
            arbitrator administered by the Indian Arbitration and Conciliation Act, 1996 (as amended from time to time).
            The Tribunal shall consist of one (1) arbitrator, the arbitration will be conducted in English and the seat of
            the arbitration shall be Bengaluru, Karnataka.
          </p>
        </li>
      </ol>     
      
      <!------------------ 15. Entire Agreement ------------------------------->     
      <h2> 15. Entire Agreement</h2>
      <p> These Terms contain the entire agreement between you and the Company with respect to use of the App, and
        shall supersede all previous communications (whether written, oral or otherwise), discussions or letters
        relating to the same. You agree that in downloading, installing and using the Application and/or in relying on
        the Services provided in connection with your use of the Application, you do not rely on any statement,
        representation, warranty or understanding made prior to these Terms save to the extent that such statement,
        representation, warranty or understanding is incorporated into these Terms.
      </p>

      <!------------------ 16. Severability ------------------------------->     
      <h2> 16. Severability</h2>
      <p> If any term or provision contained herein shall in whole or in part be held by the competent court to any
        extent to be illegal or unenforceable under applicable law, that term or provision or part shall to that
        extent be deemed not to form part of these Terms and the enforceability of the remainder of these Terms shall
        not be affected.
      </p>

      <!------------------ 17. No Waiver ------------------------------->  
      <h2> 17. No Waiver</h2>
      <p> The failure of the Company to enforce any of the terms set out herein shall not constitute a waiver of such
        a right and shall at no time and in no manner affect the right of the Company to enforce such a term at a
        later time.
      </p>

      <!------------------ 18. Assignment -------------------------------> 
      <h2>18. Assignment</h2>
      <p> The Company may assign, delegate, sub-contract or transfer any or all of the Company's rights and/or
        obligations under these Terms to any third party. You may not transfer any or all of your rights or
        obligations under these Terms to any third party.
      </p>

      <!------------------ 19. Third Party Rights -------------------------------> 
      <h2> 19. Third Party Rights</h2>
      <p> These Terms are entered into between you and the Company. For the avoidance of doubt, except as expressly
        stated in these Terms, a person who is not a party to this Terms shall have no right under the Indian Contract
        Act, 1872 and/or any other law to enforce any of the terms of these Terms.
      </p>

      <!------------------ 20. Contact Information ------------------------------->
      <h2> 20. Contact Information</h2>
      <ol>
        <li>
          <p>You may contact the Company at :<br/>
            Company name: Capitaland Services (India) Pvt Ltd. <br/>
            Address : 3rd floor, Discoverer Building, International Tech Park Bangalore, Whitefield road, Whitefield,
            Bangalore-560066<br/>
            Email: <a href="mailto:capitastar.india&#64;capitaland.com" target="_blank">capitastar.india&#64;capitaland.com</a>
          </p>
        </li>
        <li>
          <p>Any notice that the Company intends to give to you may be carried out by sending such notice to you through the Application or to any contact information you may have provided the Company with through the Application or otherwise. You are deemed to have received notice of the same upon the Company sending such notice to you through the Application or to any contact information you may have provided the Company with through the Application or otherwise.</p>
        </li>
      </ol>
      
      <!------------------ 21. Additional Terms for Google Play ------------------------------->     
      <h2> 21. Additional Terms for Google Play</h2>
      <ol>
        <li>
          <p>If the Application has been downloaded from Google Play, you agree to comply with any applicable terms
            and conditions of the same, as may be amended from time to time, including but not limited to the “Google Play
            Terms of Service” which can be found at: <a href="https://play.google.com/about/play-terms.html" target="_blank">https://play.google.com/about/play-terms/index.html</a>
          </p>
        </li>
        <li>
          <p>You also agree that you will not use the Application in any way that would result in or cause the
            Application and/or the Company to be in violation of any terms and conditions applicable to developers and
            applications on Google Play, as may be amended from time to time, including but not limited to the “Google
            Play Developer Programme Policies” and the “Google Play Developer Distribution Agreement” which can be found
            at:
            <a href="https://play.google.com/about/developer-content-policy.html"
              target="_blank">https://play.google.com/about/developer-content-policy.html</a> and
            <a href="https://play.google.com/about/developer-distribution-agreement.html"
              target="_blank">https://play.google.com/about/developer-distribution-agreement.html</a>
    
          </p>
        </li>
      </ol>
      
      <!------------------ 22. Additional Terms for Apple Store ------------------------------->     
      <h2> 22. Additional Terms for Apple Store</h2>
      <ol>
        <li>
          <p> 22.1 If the Application has been downloaded from the Apple Store or iTunes, you agree to comply with any
            applicable terms and conditions of the same, as may be amended from time to time, including but not limited to
            the “iTunes Store Terms and Conditions” which can be found at:
            <a href="http://www.apple.com/legal/internet-services/itunes/sg/terms.html"
              target="_blank">http://www.apple.com/legal/internet-services/itunes/sg/terms.html</a>
          </p>
        </li>
        <li>
          <p>You also agree that you will not use the Application in any way that would result in or cause the
            Application and/or the Company to be in violation of any terms and conditions applicable to developers and
            applications on the Apple Store or iTunes, as may be amended from time to time, including but not limited to
            the “App Store Review Guidelines” and the “Instructions for Minimum Terms of Developer’s End-User License
            Agreement” which can be found at:
            <a href="https://developer.apple.com/app-store/review/guidelines/"
              target="_blank">https://developer.apple.com/app-store/review/guidelines/</a> &nbsp;
            <a href="https://developer.apple.com/app-store/review/guidelines/"
              target="_blank">http://www.apple.com/legal/internet-services/itunes/appstore/dev/minterms/</a>
          </p>
        </li>
        <li>
          <p>The following additional terms and conditions shall apply if the Application has been downloaded from
            the Apple Store or iTunes and is intended for use on an Apple iOS-powered device.
          </p>
          <ol>
            <li>
              <p>You acknowledge that these Terms are between you and Capitaland only, and not with Apple, Inc. and/or any of its local entities (collectively, "Apple").
              </p>
            </li>
            <li>
              <p>Capitaland, and not Apple, is solely responsible for the Application and/or the provision of the App
                Services. You acknowledge that Apple has no obligation to provide maintenance and support services with
                respect to the same. To the maximum extent permitted by applicable law, Apple will have no warranty obligation
                whatsoever with respect to the Application and/or the provision of the App Services.
              </p>
            </li>
            <li>
              <p>You agree that Capitaland, and not Apple, is responsible for addressing any claims by you or any third party relating to the Application and/or the provision of the App Services or Your possession and/or use of
                the same.
              </p>
            </li>
            <li>
              <p>You agree that Capitaland, and not Apple, shall be responsible, to the extent required by these Terms, for
                the investigation, defense, settlement and discharge of any third party intellectual property infringement
                claim related to the Application and/or the provision of the App Services or your possession and use of the
                same.
              </p>
            </li>
            <li>
              <p>You represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a "terrorist supporting" country; and (ii) you
                are not listed on any U.S. Government list of prohibited or restricted parties.
              </p>
            </li>
            <li>
              <p>You agree to comply with all applicable third party terms of agreement when using the Application and/or the App Services (e.g., you must not be in violation of your network service provider's terms of agreement
                when using the Application and/or the App Services).
              </p>
            </li>
            <li>
              <p>The parties agree that Apple is a third party beneficiary to these Terms as they relate to your License of the Application, and/or the provision of the App Services. Upon your acceptance of these Terms, Apple will
                have the right (and will be deemed to have accepted the right) to enforce these Terms against you as they relate to your License of the Application, and/or the provision of the App Services as a third party
                beneficiary thereof.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>You acknowledge and agree that if any of the terms and conditions of these Terms are inconsistent with Apple's "Instructions for Minimum Terms of Develope's End-User License Agreement", the terms and conditions
            of Apple's "Instructions for Minimum Terms of Developer's End-User License Agreement” shall prevail. 
          </p>
        </li>
      </ol>
    </div>
    <div class="col-1"></div>
  </div>
</div>
<!-- <div class="row" *ngIf="!isMobile">
  <button type="submit" class="btn ml-3 mb-5">i agree</button>
</div> -->
